import { Injectable } from '@angular/core';
import { ContextService } from './context.service';
import {
  FollowingTabEventArgs,
  FollowingTabEvents,
  MaximizerFollowingTab,
} from '../models';

declare const LOAD_UID: string;

@Injectable()
export class FollowingTabService {
  constructor(private readonly context: ContextService) {}

  loadDependencies(): Promise<void> {
    return new Promise((resolve) => {
      const version = this.context.version ?? LOAD_UID;

      const style = document.createElement('link');
      style.rel = 'stylesheet';
      style.href = `${this.context.website}/ClientScript/AngularElements/styles.css?${version}`;
      const firstStyleLink = document.head.querySelector(
        'link[rel="stylesheet"]',
      );
      if (firstStyleLink) {
        document.head.insertBefore(style, firstStyleLink);
      } else {
        document.head.appendChild(style);
      }

      const scripts = [
        'ClientScript/jQuery/jquery.min.js',
        'ClientScript/MaxPage/maximizer.Events.js',
        'ClientScript/MaxPage/maximizer.FollowingTabManager.js',
        'ClientScript/MaxPage/MaxCustomAction.js',
        'mvc/Content/APILibraries/APIRequest/MaximzierData.request.js',
      ];

      let progress = 0;
      scripts.forEach((script) => {
        const tag = document.createElement('script');
        tag.src = `${this.context.website}/${script}?${version}`;
        tag.async = false;
        tag.type = 'text/javascript';
        tag.onload = () => {
          if (++progress == scripts.length) {
            resolve();
          }
        };
        document.head.appendChild(tag);
      });
    });
  }

  insideFollowingTabFrame(): boolean {
    return (
      window.frameElement?.classList.contains('max-following-tab-content') ??
      false
    );
  }

  addActionEventHandler(element: HTMLElement): void {
    if (element.id) {
      const eventHandler = new MaxCustomAction(
        element.id,
        new MaximizerDataRequest(),
      );

      element.addEventListener('actionCompleted', (args: Event) => {
        const customEvent = args as CustomEvent<unknown>;
        eventHandler.Action(customEvent.detail);
      });
    }
  }

  create(
    events: Partial<
      Record<FollowingTabEvents, (args: FollowingTabEventArgs) => void>
    >,
  ): MaximizerFollowingTab {
    const followingTab = new maximizer.FollowingTab();
    for (const [event, callback] of Object.entries(events)) {
      followingTab.on(event, callback);
    }
    return followingTab;
  }

  setTitle(tabId: string, title: string): void {
    const element = top?.document.querySelector(
      `#tab_${tabId}.max-following-tab-header`,
    );
    if (element) {
      element.textContent = title;
      element.setAttribute('aria-label', title);
    }

    if (this.insideFollowingTabFrame()) {
      document.title = title;
    }

    this.context.modules.forEach((module) => {
      module.followingWindowTabs?.forEach((tab) => {
        if (tab.id === tabId) {
          tab.title = title;
        }
      });
    });
  }
}
